



































import {Component, Vue, Prop, Inject} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import {AccelerometerWidget} from '@/views/dashboard/interfaces';
import AccelerometerSegmentDiagramBar from '@/components/widgets/AccelerometerSegmentDiagramBar.vue';
import AccelerometerSegmentDiagramLine from '@/components/widgets/AccelerometerSegmentDiagramLine.vue';
import {AxisBoundaries} from '@/components/widgets/base/bindForms/interfaces';

@Component({
  components: {
    highcharts: Chart,
    AccelerometerSegmentDiagramBar,
    AccelerometerSegmentDiagramLine,
  },
})
export default class AccelerometerSegmentDiagram extends Vue {
  @Inject() widget!: AccelerometerWidget;

  @Prop({required: true})
  currentValue!: number | null;

  @Prop()
  axisBoundaries!: AxisBoundaries;

  @Prop()
  unit!: string;

  @Prop({required: true, type: String})
  axis!: string;

  @Prop({required: true, type: String})
  axisRu!: string;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  get commonBoundaries() {
    return {
      dangerBoundary: 75,
      errorBoundary: 100,
      warningBoundary: 50,
    };
  }
}
